import React, { useState } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLVentoChecks = (props) => {
  const handleChange = props.handleChange;

  const [params, set_params] = useState(props.data.params);

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'params':
        set_params(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };
  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          Laptop required (Check parameters)
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          background: greyOutEmptyTextField(params)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='params'
          value={params}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ textAlign: 'left', '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLVentoChecks;
